import { FormattedMessage } from "react-intl";

import {
    JSMOverlayTemplate,
    SignupBackgroundLayout
} from "@/components/signup/layouts";
import SiteActivation, {
    ReturnToProduct
} from "@/components/signup/site-activation";
import { ServiceCollectionLogo } from "@/components/signup/utils";
import { ExperimentView, experiments } from "@/utils/experiment";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import {
    Headings,
    PickUpWhereYouLeftOffText,
    SubHeading,
    WelcomeBackHeading,
    WelcomeBackText
} from "../components";

const CurrentProductUserContent = () => {
    const team26VisualUpdates = checkFeatureFlagGate(
        featureFlags.cfind4831ProductOverlayModalVisualUpdates
    );
    return (
        <>
            {team26VisualUpdates ? (
                <Headings
                    main={<WelcomeBackText />}
                    sub={<PickUpWhereYouLeftOffText />}
                />
            ) : (
                <>
                    <WelcomeBackHeading />
                    <SubHeading>
                        <FormattedMessage
                            id="return-to-product-modal.header.text"
                            defaultMessage="Pick up where you left off."
                        />
                    </SubHeading>
                </>
            )}
            {/* everyone with a service collection should see a return to product experience */}
            <SiteActivation CurrentProductUser={<ReturnToProduct />} />
        </>
    );
};

export const CurrentProductUser = () => (
    <ExperimentView
        experiment={experiments.servCoLofiBackground}
        render={(value) =>
            value ? (
                <JSMOverlayTemplate size="sm">
                    <CurrentProductUserContent />
                </JSMOverlayTemplate>
            ) : (
                <SignupBackgroundLayout
                    ProductLogo={<ServiceCollectionLogo />}
                    theme="yellow"
                >
                    <CurrentProductUserContent />
                </SignupBackgroundLayout>
            )
        }
    />
);
